export const filter = {
    id: "",
    part: "",
    created_at: "",
    updated_at: "",
};
